export default __webpack_public_path__ + "static/media/marketingToolsImg.611a78cb.webp";